import { useTranslation } from 'react-i18next';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface StatusIndicatorProps {
  status: 'recording' | 'uploading' | 'processing' | 'done' | null;
}

export function StatusIndicator({ status }: Readonly<StatusIndicatorProps>) {
  const { t } = useTranslation();

  if (!status) {
    return (
      <div role="status" aria-live="polite" aria-atomic="true" data-testid="status-indicator"></div>
    );
  }

  const isDone = status === 'done';
  const isActive = status === 'uploading' || status === 'processing';

  return (
    <div role="status" aria-live="polite" aria-atomic="true" data-testid="status-indicator">
      {(isActive || isDone) && (
        <Card>
          <CardContent className="flex items-center justify-center gap-2 py-4">
            {isActive && <Loader2 className="h-5 w-5 animate-spin text-primary" />}
            {isDone && <CheckCircle2 className="h-5 w-5 text-success" />}
            <span className={isDone ? 'font-medium text-success' : 'text-muted-foreground'}>
              {t(`status.${status}`)}
            </span>
          </CardContent>
        </Card>
      )}
      {status === 'recording' && (
        <p className="text-center text-sm font-medium text-destructive">{t(`status.${status}`)}</p>
      )}
    </div>
  );
}
